export enum EmployerQueries {
  lastSearch = 'last-search',
  filterParams = 'filterParams',
  ListOfWorkers = 'listOfWorkers',
  workerData = 'workerData',
  interviewTypes = 'interviewTypes',
  historyList = 'historyList',
  lastSharedList = 'lastSharedList',
}
